import CVPAuthConfig from 'common/config/cvp-auth';
import CVPStrings from 'common/config/cvp-strings';
import Environment from 'common/utils/environment';
import { action, computed, extendObservable, observable, reaction, when } from 'mobx';
import { cloneDeep, get } from 'lodash';
import { trackMetrics } from 'common/utils/analytics';


const { AuthManager } = window.CVP;


class CVPAuth {
    @observable authenticated = false;
    @observable cancelled = false;
    @observable closed = true;
    @observable opened = false;
    @observable provider = null;
    @observable ready = false;
    @observable token = null;


    constructor() {
        this.clientId = CVPAuthConfig.clientId;
        Object.assign(window.CVP.AuthManager.Strings, CVPStrings);
        AuthManager.on('authNFail', this.onAuthNFail, this);
        AuthManager.on('authNPass', this.onAuthNPass, this);
        AuthManager.on('authZFail', this.onAuthZFail, this);
        AuthManager.on('authZPass', this.onAuthZPass, this);
        AuthManager.on('pickerCanceled', this.onPickerCancelled, this);
        AuthManager.on('pickerClosed', this.onPickerClosed, this);
        AuthManager.on('pickerOpened', this.onPickerOpened, this);
        AuthManager.on('pickerHelpClicked', this.onPickerHelpClicked, this);
        AuthManager.on('pickerStateChange', this.onPickerStateChange, this);
        AuthManager.on('initReady', this.onInitReady, this);

        if (!Environment.mobile) {
            AuthManager.init(CVPAuthConfig);
        }

        this.readyListener = when(() => this.ready, () => {
            AuthManager.isAuthenticated();
        });
        this.authListener = reaction(() => this.authenticated, authenticated => {
            if (!authenticated) {
                AuthManager.logout();
                trackMetrics('mvpd-logout', '');
            } else if (!this.token) {
                AuthManager.checkAuthorization(this.clientId);
            }
        }, false, 1000);
    }


    @computed get isAuthenticated() {
        return !!(this.authenticated && this.provider && this.token);
    }


    @computed get providerID() {
        return get(this, 'provider.ID', null);
    }


    @computed get providerInfo() {
        if (!this.isAuthenticated) return null;
        return {
            name: get(this, 'provider.displayName', ''),
            image: get(this, 'provider.cobrand[0].url', null)
        };
    }


    destroy() {
        AuthManager.off('authNFail', this.onAuthNFail, this);
        AuthManager.off('authNPass', this.onAuthNPass, this);
        AuthManager.off('authZFail', this.onAuthZFail, this);
        AuthManager.off('authZPass', this.onAuthZPass, this);
        AuthManager.off('initReady', this.onInitReady, this);
        this.authListener();
        this.authListener = null;
        this.readyListener();
        this.readyListener = null;
    }


    login() {
        if (!this.authenticated) {
            AuthManager.getAuthentication();
        }
    }


    @action logout = () => {
        this.authenticated = false;
        this.provider = null;
        this.token = null;
    };


    onAuthNFail = () => {
        this.logout();
    };


    @action onAuthNPass = ({ mvpdConfig }) => {
        extendObservable(this, {
            authenticated: true,
            provider: cloneDeep(mvpdConfig)
        });
    };


    onAuthZFail = () => {
        this.token = null;
    };


    @action onAuthZPass = () => {
        const token = AuthManager.getAccessToken();
        this.token = token ? cloneDeep(token) : null;
    };


    @action onInitReady = () => {
        this.ready = true;
    };


    @action onPickerCancelled = () => {
        this.cancelled = true;
    };


    @action onPickerClosed = () => {
        this.closed = true;
        this.opened = false;
    };


    onPickerHelpClicked = () => {
        const helpWindow = window.open('http://www.adultswim.com/footer/help/watch-as-faq.html', '_blank');
        if (helpWindow) helpWindow.focus();
    };


    @action onPickerOpened = () => {
        this.cancelled = false;
        this.closed = false;
        this.opened = true;
    };


    onPickerStateChange = (e) => {
        if (e.state === 'success') {
            AuthManager.closePicker();
        }
    };

}


export default new CVPAuth();



// WEBPACK FOOTER //
// ./src/common/stores/cvp-auth.js